import { useEffect } from "react";

import useThemeStore from "src/store/themeStore";

const DARK_THEME_CLASS = "dark-theme";

/** Keeps <body>'s dark-theme class in sync with the global theme store. */
export function useDarkTheme() {
  const { isDarkTheme, toggleDarkTheme } = useThemeStore();

  useEffect(() => {
    document.body.classList.toggle(DARK_THEME_CLASS, isDarkTheme);
  }, [isDarkTheme]);

  return { isDarkTheme, toggleDarkTheme };
}
